import initStickyCategories from "../shared/sticky-categories";

document.addEventListener("DOMContentLoaded", function () {
    initStickyCategories();

    const modalEl = document.getElementById("productModal");
    const bsModal = new bootstrap.Modal(modalEl);
    const getModal = () =>
        new bootstrap.Modal(document.getElementById("checkoutModal"));

    window.addEventListener("open-product-modal", () => {
        bsModal.show();
    });

    window.addEventListener("close-product-modal", () => {
        bsModal.hide();
    });

    const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });

    window.addEventListener("alert", ({ detail: { type, message } }) => {
        Toast.fire({
            icon: type,
            title: message,
        });
    });

    window.addEventListener("open-checkout", () => {
        getModal().show();
    });

    window.addEventListener("close-checkout", () => {
        const el = document.getElementById("checkoutModal");
        const instance = bootstrap.Modal.getInstance(el);
        if (instance) instance.hide();
    });

    window.addEventListener("open-whats", (e) => {
        const url = e.detail?.url;
        if (!url) return;
        window.location.assign(url);
    });

    // ============================================
    // FILTRO DE SUBCATEGORÍAS POR SECCIÓN
    // Comparte los 3 modelos del menú (theme-1, theme-2, theme-3).
    // Click en un chip de subcategoría dentro de una sección -> oculta los
    // productos de ESA sección que no matchean. No toca otras secciones.
    // ============================================

    document.addEventListener("click", (e) => {
        const chip = e.target.closest(
            "[data-subcat-filter] button[data-sub-id]"
        );
        if (!chip) return;

        const container = chip.closest("[data-subcat-filter]");
        const section = chip.closest("[data-subcat-section]");
        if (!container || !section) return;

        const subId = chip.dataset.subId;

        // Marcar el chip activo (visual)
        container
            .querySelectorAll("button[data-sub-id]")
            .forEach((btn) => {
                btn.classList.toggle("is-active", btn === chip);
            });

        // Filtrar los productos de ESTA sección
        section.querySelectorAll("[data-sub-id]").forEach((card) => {
            if (card.tagName === "BUTTON") return; // saltar los chips mismos
            const matches =
                subId === "all" || card.dataset.subId === subId;
            card.style.display = matches ? "" : "none";
        });
    });
});

/**
 * Ubicación del cliente para delivery.
 */
document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-geo-button]");
    if (!button) return;

    const field = button.closest(".checkout-sheet__field");
    const label = button.querySelector("[data-geo-label]");
    const errorEl = field ? field.querySelector("[data-geo-error]") : null;

    const fail = (message) => {
        button.disabled = false;
        if (label) label.textContent = "Adjuntar mi ubicación GPS";
        if (errorEl) {
            errorEl.textContent = message;
            errorEl.hidden = false;
        }
    };

    if (errorEl) errorEl.hidden = true;

    if (!navigator.geolocation) {
        fail("Tu navegador no permite compartir la ubicación.");
        return;
    }

    if (!window.isSecureContext) {
        fail("Para compartir tu ubicación el sitio debe abrirse con https.");
        return;
    }

    button.disabled = true;
    if (label) label.textContent = "Buscando tu ubicación…";

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const { latitude, longitude, accuracy } = position.coords;
            const component = button.closest("[wire\\:id]");

            if (!component || !window.Livewire) {
                fail("No pudimos guardar la ubicación. Intenta de nuevo.");
                return;
            }

            window.Livewire.find(
                component.getAttribute("wire:id")
            ).call("setDeliveryLocation", latitude, longitude, accuracy);
        },
        (error) => {
            const messages = {
                1: "No diste permiso. No pasa nada: con la dirección escrita es suficiente.",
                2: "No pudimos obtener tu ubicación. Revisa el GPS e intenta de nuevo.",
                3: "La búsqueda tardó demasiado. Intenta de nuevo.",
            };
            fail(messages[error.code] || "No pudimos obtener tu ubicación.");
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
});
